import React from 'react'
import { Button, Form, FormControl, FormLabel } from 'react-bootstrap'
import PropTypes from 'prop-types';
import { SkuConstraints, SkuParamListener } from '../../domain/models/SkuDetail';
import { useState } from 'react';
import { SkuButtonFlowListener } from './SkuDetailFlowButtons';
import { AnimationTypeValues, getAnimationClass } from '../../presentation/constants/AnimationType';
import { RequestParam } from '../../domain/models/RequestParam';
import { SkuConstraintFormat } from '../../domain/constants/SkuConstraintFormat';

export const SkuInputTextWithConfirmation = ({
    label,
    nameParam,
    constraints,
    skuParamListener,
    buttonFlowListener,
    animationType,
    uppercase
}: any) => {

    function getType() {
        let type = "text"
        switch (constraints.format) {
            case SkuConstraintFormat.Numeric:
                type = "number"
                break;
            default:
                type = "text";
                break;
        }
        return type;
    }

    const [state, setState] = useState({
        value: "",
        valueError: "",
        valueIsValid: true,
        confirm: "",
        confirmError: "",
        confirmIsValid: true
    })

    function checkMaxLength(text: string): string {
        if (constraints?.maxLength && text.length > constraints?.maxLength) {
            return text.substring(0, constraints.maxLength)
        } else {
            return text;
        }
    }

    function hasMinLength(text: string): boolean {
        return text.length >= (constraints.minLength ?? 0);
    }

    function handleValueChange(value: string) {
        setState((s) => {
            return {
                ...s,
                value: checkMaxLength(value),
                valueError: "",
                valueIsValid: true,
            }
        })
    }

    function handleConfirmChange(value: string) {
        const confirm = checkMaxLength(value);
        let confirmError = "";
        setState((s) => {
            return {
                ...s,
                confirm: confirm,
                confirmError: confirmError,
                confirmIsValid: true,
            }
        })
    }

    function handleContinue(e: any) {
        e.preventDefault();
        if (state.value.length === 0) {
            setState((s) => {
                return {
                    ...s,
                    valueError: "Campo obligatorio",
                    valueIsValid: false,
                    isValid: false
                }
            })
            return;
        }
        if (!hasMinLength(state.value)) {
            setState((s) => {
                return {
                    ...s,
                    valueError: `Longitud mínima de caracteres es de ${constraints?.minLength}`,
                    valueIsValid: false
                }
            })
            return;
        }

        if (state.value !== state.confirm) {
            setState((s) => {
                return {
                    ...s,
                    confirmError: "Los campos no coinciden",
                    confirmIsValid: false
                }
            })
            return;
        }
        skuParamListener?.addParam(nameParam, state.value)
        buttonFlowListener?.onContinuePressed(new RequestParam(nameParam, `${state.value}`,`${label}`))
    }

    let classUppercase = '';
    if (uppercase) classUppercase = 'text-uppercase'
    return (
        <Form
            className={getAnimationClass(animationType)}
            onSubmit={handleContinue}>
            <Form.Group className="m-4">
                {label && <FormLabel>{label}</FormLabel>}
                <FormControl
                    name={nameParam}
                    as="input"
                    type={getType()}
                    value={state.value}
                    isInvalid={!state.valueIsValid}
                    className={classUppercase}
                    onChange={(e: any) => {
                        handleValueChange(e.target.value)
                    }} />
                <FormControl.Feedback type="invalid">
                    {state.valueError}
                </FormControl.Feedback>
            </Form.Group>

            <Form.Group className="m-4">
                {label && <FormLabel>Confirme {label}</FormLabel>}
                <FormControl
                    className={`text-center ${classUppercase}`}
                    as="input"
                    type={getType()}
                    value={state.confirm}
                    isInvalid={!state.confirmIsValid}
                    onChange={(e: any) => {
                        handleConfirmChange(e.target.value);
                    }} />
                <FormControl.Feedback type="invalid">
                    {state.confirmError}
                </FormControl.Feedback>
            </Form.Group>
            {
                buttonFlowListener?.onBackPressed &&
                <Button variant="link" className="float-left ml-4 mt-4"
                    onClick={buttonFlowListener.onBackPressed}> Regresar </Button>

            }
            {
                buttonFlowListener?.onContinuePressed &&
                <Button
                    variant="primary" className="float-right mr-4 mt-4"
                    type="submit"> Continuar </Button>
            } 
        </Form>
    )
}

SkuInputTextWithConfirmation.propTypes = {
    label: PropTypes.string,
    constraints: PropTypes.instanceOf(SkuConstraints),
    nameParam: PropTypes.string,
    skuParamListener: PropTypes.instanceOf(SkuParamListener),
    buttonFlowListener: PropTypes.instanceOf(SkuButtonFlowListener),
    animationType: PropTypes.oneOf(AnimationTypeValues),
    uppercase: PropTypes.bool
}